import { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  apiBaseUrl: 'https://dev.api.schenck.one/acm',
  redirectUrl: 'https://dev.accountmanager.schenck.one/',
  clientId: 'e0466501-8879-46cc-a9d7-9be8a18488d7',
  authority: 'https://login.microsoftonline.com/36515c62-8878-4f10-a7f4-561a4c17bef7',
  scope: 'api://e0466501-8879-46cc-a9d7-9be8a18488d7/ACM.API',
};
